import type { LucideIcon } from 'lucide-react';
import {
  House,
  Car,
  Search,
  History,
  User,
  Building2,
  Users,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Rótulo curto para tab bar mobile. */
  shortLabel?: string;
}

export interface NavSection {
  title?: string;
  items: NavItem[];
}

/** Rota inicial após login / perfil completo. */
export const defaultAppRoute = '/available-spots';

export const userNavItems: NavItem[] = [
  { to: '/dashboard', label: 'Início', shortLabel: 'Início', icon: House },
  {
    to: '/available-spots',
    label: 'Vagas disponíveis',
    shortLabel: 'Vagas\ndisponíveis',
    icon: Search,
  },
  { to: '/my-parking-spots', label: 'Minhas vagas', shortLabel: 'Minhas\nvagas', icon: Car },
  { to: '/my-spot-usages', label: 'Histórico', shortLabel: 'Histórico', icon: History },
  { to: '/edit-profile', label: 'Perfil', icon: User },
];

/** Abas principais da navbar inferior (mobile). */
export const mobileTabNavItems: NavItem[] = userNavItems.slice(0, 4);

export const condominiumsNavItem: NavItem = {
  to: '/admin/condominiums',
  label: 'Condomínios',
  icon: Building2,
};

export const usersNavItem: NavItem = {
  to: '/admin/users',
  label: 'Usuários',
  icon: Users,
};

export const adminNavItems: NavItem[] = [condominiumsNavItem, usersNavItem];

export function getAdminNavItems(options?: {
  isGlobalAdmin?: boolean;
  isCondominiumManager?: boolean;
}): NavItem[] {
  const items: NavItem[] = [];
  if (options?.isGlobalAdmin || options?.isCondominiumManager) {
    items.push(condominiumsNavItem);
  }
  if (options?.isGlobalAdmin) {
    items.push(usersNavItem);
  }
  return items;
}

export function getNavSections(options?: {
  isGlobalAdmin?: boolean;
  isCondominiumManager?: boolean;
}): NavSection[] {
  const sections: NavSection[] = [{ items: userNavItems }];
  const adminItems = getAdminNavItems(options);

  if (adminItems.length > 0) {
    sections.push({
      title: 'Administração',
      items: adminItems,
    });
  }

  return sections;
}

/** Drawer mobile: só admin (abas principais ficam na navbar inferior). */
export function getMobileDrawerSections(options?: {
  isGlobalAdmin?: boolean;
  isCondominiumManager?: boolean;
}): NavSection[] {
  const adminItems = getAdminNavItems(options);
  if (adminItems.length === 0) return [];

  return [
    {
      title: 'Administração',
      items: adminItems,
    },
  ];
}
